<!-- 系统管理-菜单管理 -->
<template>
  <div>
    <!-- 卡片 -->
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <md-button v-if="!had_organi" @click="open_addOrga" class="diy-button-has-icon diy-blue left-icon">
          <md-icon>add</md-icon>
          {{$I18n("found_orga")}}
        </md-button>
        <h3 style="margin-top: 5px;">{{$I18n("people_info")}}</h3>
        <div class="info-cards">
          <div class="info-card" style="background: linear-gradient(139deg, #568EFE, #0149DA);">
            <div class="title">{{$I18n("no_sect")}}</div>
            <div class="body">
              <div>
                <img class="type-icon" src="/img/haiqora/ora/mechan.png" />
              </div>
              <div class="number">10</div>
            </div>
          </div>
          <div class="info-card" style="background: linear-gradient(128deg, #7874F1, #5B58B9);">
            <div class="title">{{$I18n("no_person")}}</div>
            <div class="title"></div>
            <div class="body">
              <div>
                <img class="type-icon" src="/img/haiqora/ora/person.png" />
              </div>
              <div class="number">9999</div>
            </div>
          </div>
          <div class="info-card" style="background: linear-gradient(124deg, #19C4D4, #00A8B8);">
            <div class="title">{{$I18n("no_equi")}}</div>
            <div class="body">
              <div>
                <img class="type-icon" src="/img/haiqora/ora/dev.png" />
              </div>
              <div class="number">9999</div>
            </div>
          </div>
        </div>
              
        
        <h3>{{$I18n("app_man_1")}}</h3>
        <div class="approvals-form" style="margin-bottom: 5px;">
          <common-form-item 
            style="margin-bottom: 16px;align-items: flex-start; "
            :labelweight="160"
            v-for="item in form_cardData" 
            v-model="formData.Form[item.keys]" 
            :error="formData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <template slot="icon">
              <div>
                <image-select :disabled="item.disabled" :path="formData.Form.icon" @updatePath="value => formData.Form.icon = value" :file_type="['jpge','jpg','png']" :file_size_mb="8"/>
                <div>{{$I18n("inst_info_4")}}</div>
              </div>
            </template>
          </common-form-item>
          <div v-if="formData.Form.role_id === 1" style="text-align: left; margin-left: 160px;">
            <md-button @click="resetForm" class="diy-black left-icon">{{$I18n("reset")}}</md-button>
            <md-button @click="setForm" class="diy-back-blue">{{$I18n("save")}}</md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <!-- 弹窗 -->
      <simple-modal 
      ref    = "modal"
      :title = "$I18n('inst_info_1')"
      @submit= "modal_submit"
    >
      <template slot="body">
        <!-- 表单-修改/添加菜单表单 -->
        <common-form-item 
          style="margin-bottom: 16px;"
          :labelweight="160"
          v-for="item in form_modalData" 
          v-model="modalData.Form[item.keys]" 
          :error="modalData.Error[item.keys]" 
          :key="item.keys" v-bind="item"
        >
          <template slot="icon">
            <image-select :path="modalData.Form.icon" @updatePath="value => modalData.Form.icon = value" :file_type="['jpge','jpg','png']" :file_size_mb="8"/>
          </template>
        </common-form-item>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";
// 国家、城市
import c_en from "/public/ucfg/countries_en.json";
import c_cn from "/public/ucfg/countries_en.json";
export default {
  props:["sel_organi"],
  data() {
    let modalData = new FormClass({ // 弹窗-表单数据
      name   : {
        init    : "",
        check   : "smallstr",
        errormsg: this.$I18n("inst_info_3"),
      },
      industry  : "",
      scale     : "",
      country   : "",
      addr      : {
        init    : "",
        check   : "smallstr",
        errormsg: this.$I18n("full_addr_len"),
      },
      dept_name : "",
      icon      : "",
    });
    modalData.Errmsgsort = ["name", "addr"];
    let formData = new FormClass({ // 表单数据-当前机构数据
      name      : {
        init    : "",
        check   : "smallstr",
        errormsg: this.$I18n("inst_info_3"),
      },
      industry  : "",
      scale     : "",
      country   : "",
      addr      : {
        init    : "",
        check   : "smallstr",
        errormsg: this.$I18n("full_addr_len"),
      },
      dept_name : "",
      icon      : "",
    })
    formData.Errmsgsort = ["name", "addr"];
    return {
      organi: [],
      modalData,
      formData,
      value: null,
      countrys : this.$router.history.current.query.lang === "zh-CN" ?c_cn :c_en,
    };
  },
  mounted : function() {
    this.getOrgani()
      .then(() => {
        this.resetForm();
      });
  },
  watch: {
    sel_organi(){
      this.resetForm();
    },
    organi(){
      this.resetForm();
    },
  },
  computed: {
    had_organi(){
      if(!this.organi || this.organi.length === 0){
        return true
      }
      return this.organi.some(i => i.role_id === 1)
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("inst_info_2"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
          placeholder: this.$I18n('inst_info_3'),
        },{
          label   : this.$I18n("sector"),
          keys    : "industry",
          type    : "select",
          placeholder: this.$I18n('pls_select'),
          options : this.$Param.industrySelect.map(i => {
            return {
              id  : this.$I18n(i.name),
              name: this.$I18n(i.name),
            }
          }),
        },{
          label   : this.$I18n("size_of_staff"),
          keys    : "scale",
          type    : "select",
          placeholder: this.$I18n('pls_select'),
          options : this.$Param.scaleSelect.map(i => {
            if(i.is_i18n){
              return {
                id  : this.$I18n(i.name),
                name: this.$I18n(i.name),
              }
            }
            return {
              id  : i.name,
              name: i.name,
            }
          })
        },{
          label   : this.$I18n("country_area"),
          keys    : "country",
          type    : "select",
          placeholder: this.$I18n('pls_select'),
          options : this.countrys.map(i => {
            return {
              id  : i.name,
              name: i.name,
            }
          }),
        },{
          label   : this.$I18n("full_addr"),
          keys    : "addr",
          type    : "input",
          placeholder: this.$I18n('pls_enter'),
        },{
          label   : this.$I18n("inst_info_9"),
          keys    : "icon",
        }
      ]
    },
    form_cardData(){
      const disabled = this.formData.Form.role_id !== 1;
      return [
        {
          label   : this.$I18n("inst_info_2"),
          keys    : "name",
          type    : "input",
          disabled: disabled,
          required: true,
        },{
          label   : this.$I18n("sector"),
          keys    : "industry",
          type    : "select",
          disabled: disabled,
          options : this.$Param.industrySelect.map(i => {
            return {
              id  : this.$I18n(i.name),
              name: this.$I18n(i.name),
            }
          }),
        },{
          label   : this.$I18n("size_of_staff"),
          keys    : "scale",
          type    : "select",
          disabled: disabled,
          options : this.$Param.scaleSelect.map(i => {
            if(i.is_i18n){
              return {
                id  : this.$I18n(i.name),
                name: this.$I18n(i.name),
              }
            }
            return {
              id  : i.name,
              name: i.name,
            }
          })
        },{
          label   : this.$I18n("country_area"),
          keys    : "country",
          type    : "select",
          disabled: disabled,
          options : this.countrys.map(i => {
            return {
              id  : i.name,
              name: i.name,
            }
          }),
        },{
          label   : this.$I18n("full_addr"),
          keys    : "addr",
          type    : "input",
          disabled: disabled,
        },{
          label   : this.$I18n("inst_info_9"),
          disabled: disabled,
          keys    : "icon",
        }
      ]
    },
    // 获取对应城市
    m_provinces(){
      if(!this.modalData.Form.country){
        return []
      }
      const country = this.countrys.filter(i => i.name === this.modalData.Form.country)
      if(country.length === 0){
        return []
      }
      return country[0].states
    },
    f_provinces(){
      if(!this.formData.Form.country){
        return []
      }
      const country = this.countrys.filter(i => i.name === this.formData.Form.country)
      if(country.length === 0){
        return []
      }
      return country[0].states
    },
  },
  methods: {
    // 重置 页面表格
    resetForm(){
      if(this.organi.length === 0 || !this.sel_organi){
        this.formData.Reset();
        return
      }
      const item = this.organi.filter(i => i.id === this.sel_organi)[0];
      if(!item){
        this.formData.Reset();
        return
      }
      this.formData.Update(item)
    },
    // 提交 页面表格
    setForm(){
      if(this.formData.Check()){
        this.$errorMsg(this.formData.ErrMsg ?this.formData.ErrMsg :this.$I18n("pls_check_verify"))
        return 
      }
      this.$api.s_Organi({
        ...this.formData.Form,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.$emit('reget_organi')
        }))
        .catch(this.$Catch(this.$I18n("edit_fail")))
    },
    open_addOrga(){
      this.modalData.Reset();
      this.$refs.modal.open();
    },
    // 提交 "添加机构" 弹窗
    modal_submit(){
      if(this.modalData.Check()){
        this.$errorMsg(this.modalData.ErrMsg ?this.modalData.ErrMsg :this.$I18n("pls_check_verify"))
        return 
      }
      this.$api.a_Organi({
        ...this.modalData.Form,
        dept_name : "Default Department",
        loc_name : "Default area",
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("add_success"));
          this.$refs.modal.close();
          this.$emit('reget_organi')
        }))
        .catch(err => {
          if(err.code === 8010){
            this.$errorMsg(this.$I18n("error_code_8010"))
          } else {
            this.$errorMsg(this.$I18n("add_fail") + `[${err.code}]`)
          }
        })
    },
    // 查询机构列表
    getOrgani(){
      return this.$api.g_Organi({})
        .then(res => {
          this.organi = res.data;
        })
    },
  },
}
</script>
<style scoped>
  h3{
    font-size: 13px;
    font-weight: 700;
    border-left: 2px #129BFF solid;
    padding-left: 4px;
  }
  .approvals-form{
    width: 480px;
  }
  .approvals-form /deep/ .border-input{
    border-color: rgb(126, 126, 126) !important;
  }
  .info-cards{
    display: flex;
    margin: 5px -12.5px;
  }
  .info-card{
    width: 265px;
    height: 140px;
    border-radius: 6.5px;
    border: 1px solid #D9D9D9;
    color: #FFFFFF;
    margin: 0 12.5px;
  }
  .info-card .title, .info-card .body{
    color: #FFF;
    margin-top: 18px;
    margin-left: 20px;
  }
  .info-card .title{
    font-size: 16.5px;
    font-weight: 700;
  }
  .info-card .body{
    display: flex;
    margin-top: 15px;
  }
  .info-card .number{
    margin-left: 20px;
    font-size: 45px;
    font-weight: 700;
    line-height: 50px;
  }
  .type-icon{
    width: 50px;
    height: 50px;
  }

</style>